import { KeyValues5, TokenFormatType } from "src/service/local.service";

export const replaceAll = (fullValue: string, toReplaceValue: string = '', replaceWith: string = ''): string => {
    if (fullValue) {
        var regExp = new RegExp(toReplaceValue, 'g');
        var newStr = fullValue.replace(regExp, replaceWith);
        return newStr;
    } else {
        return '';
    }
}

export const GetTokenDateFormat = (tokenFormatType: TokenFormatType, localDate: Date, spliter?: string): string => {
    let dateNow = localDate;
    let month = dateNow.getMonth() + 1;
    if (!spliter) {
        spliter = '';
    }
    switch (tokenFormatType) {
        case TokenFormatType.DayMonthYear: {
            return [(dateNow.getDate() > 9 ? '' : '0') + dateNow.getDate().toString(), (month > 9 ? '' : '0') + month.toString(), dateNow.getFullYear().toString()].join(spliter);
        } break;
        default: {
            return [dateNow.getFullYear().toString(), (month > 9 ? '' : '0') + month.toString(), (dateNow.getDate() > 9 ? '' : '0') + dateNow.getDate().toString()].join(spliter);
        } break;
    }
}

export const GetPriceIncludeTax = (basePrice: number, businessTaxes: KeyValues5[], productTaxes: KeyValues5[], isNotConsiderTax?: boolean): number => {
    let total = 0;
    if (basePrice > 0) {
        total = basePrice;
        if (productTaxes.length == 0) {
            productTaxes = businessTaxes;
        }

        productTaxes.forEach(tax => {
            let taxPercentage: string = isNotConsiderTax && tax.v4 != 'discount' ? '0' : tax.v3;

            if (!isNotConsiderTax) {
                if (typeof taxPercentage == 'number') {
                    taxPercentage = (taxPercentage as number).toString();
                }
                if (!taxPercentage) {
                    const businessTax = businessTaxes.find(x => x.key == tax.key);
                    if (businessTax) {
                        taxPercentage = businessTax.v3;
                    }
                }
            }
            if (taxPercentage || taxPercentage == '0') {
                const dblPercentage: number = (parseFloat(taxPercentage) / 100) * basePrice;
                if (tax.v4 == 'discount') {
                    total -= dblPercentage;
                } else if (!isNotConsiderTax) {
                    total += dblPercentage;
                }
            }
        });

    }
    return total;
}

export const GetBaseFromPriceIncludeTax = (taxIncludedAmount: number, businessTaxes: KeyValues5[], productTaxes: KeyValues5[], isNotConsiderTax?: boolean): number => {
    //this.onSetFinalTax();
    let baseAmount = 0;
    let totalTaxPercent = 0;

    if (taxIncludedAmount <= 0) {
        return 0;
    }

    productTaxes.forEach(tax => {
        let taxPercentage: string =
            isNotConsiderTax && tax.v4 !== 'discount'
                ? '0'
                : (tax.v3 ?? '');

        if (!isNotConsiderTax && !taxPercentage) {
            const businessTax = businessTaxes.find(x => x.key === tax.key);
            if (businessTax?.v3) {
                taxPercentage = businessTax.v3;
            }
        }

        if (taxPercentage || taxPercentage === '0') {
            const percent = parseFloat(taxPercentage);

            if (!isNaN(percent)) {
                if (tax.v4 === 'discount') {
                    totalTaxPercent -= percent;
                } else if (!isNotConsiderTax) {
                    totalTaxPercent += percent;
                }
            }
        }
    });

    const divisor = 1 + totalTaxPercent / 100;

    if (divisor <= 0) {
        return 0;
    }

    baseAmount = taxIncludedAmount / divisor;

    return baseAmount;
}

export const GetFinancialYear = (localDate: Date, countryCode: string): number => {
    const year = localDate.getUTCFullYear();
    const month = localDate.getUTCMonth() + 1; // JS month starts from 0
    switch (countryCode.toLowerCase()) {
        case 'ind': {
            // If month is Jan(1), Feb(2) or Mar(3), use previous year as FY start
            return month <= 3 ? year - 1 : year;
        } break;
        default: {
            return year;
        } break;
    }
}

export const NumberToWordsWithDecimal = (num: number | string): string => {
    num = parseFloat(replaceAll(num.toString(), ',', ''));

    const ones = ["zero", "one", "two", "three", "four", "five",
        "six", "seven", "eight", "nine"];
    const teens = ["ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen",
        "sixteen", "seventeen", "eighteen", "nineteen"];
    const tens = ["", "", "twenty", "thirty", "forty", "fifty",
        "sixty", "seventy", "eighty", "ninety"];
    const thousands = ["", "thousand", "million"];

    const helper = (n: number): string => {
        if (n < 10) return ones[n];
        if (n < 20) return teens[n - 10];
        if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        if (n < 1000) return ones[Math.floor(n / 100)] + " hundred" +
            (n % 100 ? " " + helper(n % 100) : "");
        return "";
    };

    const convertIntegerPart = (n: number): string => {
        if (n === 0) return "zero";
        let result = "";
        let i = 0;
        while (n > 0) {
            const rem = n % 1000;
            if (rem !== 0) {
                result = helper(rem) + (thousands[i] ? " " + thousands[i] : "") +
                    (result ? " " + result : "");
            }
            n = Math.floor(n / 1000);
            i++;
        }
        return result.trim();
    };

    const [integerPart, decimalPart] = num.toString().split(".");

    let words = convertIntegerPart(parseInt(integerPart));

    if (decimalPart) {
        const decimalWords = decimalPart
            .split("")
            .map(d => ones[parseInt(d)])
            .join(" ");
        words += " point " + decimalWords;
    }

    return words;
}